import { isEmpty } from 'lodash'
import { SIMPLE_EMAIL_REGEX } from '../../gateway/gateway'
import { getErrorMessages } from './constants'
import { isSessionValid } from '../session'
import { LoftRecord } from './record'

export const throwOnInvalidSession = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  if (
    !isSessionValid(state.session?.expiration_date || false, state.session?.access_token || false)
  ) {
    throw errorMessages.INVALID_SESSION
  }
}

export const throwOnInvalidAttendees = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  const attendees = await state.getAsync('attendees')

  if (!attendees?.length) {
    throw errorMessages.INVALID_ATTENDEES
  }
}

export const throwOnInvalidRecurrence = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  const recurrence = await state.getAsync('recurrence')

  if (!isEmpty(recurrence)) {
    throw errorMessages.INVALID_RECURRENCE
  }
}

export const throwOnInvalidRecipient = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  if (!SIMPLE_EMAIL_REGEX.test(state.emailAddress || '')) {
    throw errorMessages.RECIPIENT_INVALID
  }
}

export const throwOnInvalidPerson = async (state: LoftRecord) => {
  const errorMessages = getErrorMessages()
  const person = await state.getAsync('recipient')
  if (person && (person.do_not_contact || person.do_not_email)) {
    throw errorMessages.RECIPIENT_DNC
  }
}
